var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h1',{attrs:{"id":_vm.props.elementId},domProps:{"innerHTML":_vm._s(_vm.props.content)}})}
var staticRenderFns = []

export { render, staticRenderFns }